/* eslint-disable react-hooks/exhaustive-deps */
import { useRef } from "react";

// @material-ui/core components
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  ButtonBase,
  Grid,
  Paper,
  Typography,
  CardContent,
} from '@material-ui/core';

import { makeStyles } from "@material-ui/core/styles";

import ImagePlaceholder from "components/Image/ImagePlaceholder";
import componentStylesDialog from "assets/theme/components/dialog";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles({
  paper: { overflow: "hidden"},
});

const useStylesDialog = makeStyles(componentStylesDialog);

const DataExchange = ({ label, value }) => {
  return (
    <Typography gutterBottom variant="subtitle2" style={{fontSize:'13px', marginBottom:'0.4rem'}}>
      <span style={{fontWeight:'600', textAlign:'justify'}}>{label?.toUpperCase()}</span> {value}
    </Typography>
  );
};

const OrderConfirmation = ({ 
  itens,
  onClose,
 }) => {
  const classes = { ...useStyles(), ...useStylesDialog() };
  const detailsRef = useRef(null);

  const isMobile = IsMobile();

  const handleVerifyReason = (motivo) => {
    switch (motivo) {
      case 'ARREPENDIMENTO':
        return 'Arrependimento/Desistência'
        
      case 'DEFEITO':
        return 'Produto com defeito'
      case 'NAOGOSTOU':
        return 'Não gostou'
      case 'OUTROS':
        return 'Outros'
      default:
        console.log(``);
    }
  }

  return (
    <Dialog
      open={Boolean(itens)}
      onClose={onClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      classes={{ paper: classes.paper }}
      maxWidth="lg"
    >
      <>
        <DialogContent
          ref={detailsRef}
          style={{
            paddingRight: "0px",
            marginRight: "1.5rem",
            overflowX: "hidden",
          }}
        >
          <>
            <Grid container>
              <Grid item xs={12}>
              <Typography 
                variant="h5" 
                component="h5" 
                className={classes.dialogTitle} 
                style={{margin: '1rem 0 0 1rem'}}
              >
                Deseja seguir com a troca/devolução dos itens?
              </Typography>
              {
                itens?.map((itemAtendimento, index) => {
                  return (
                    <CardContent key={index}>
                      <Grid container>
                        <Grid item xs={12}>
                        <Paper key={index} className={classes.paper}>
                          <Grid container spacing={1} style={{padding:'1rem', flexDirection: isMobile ? 'column' : 'row'}}>
                            <Grid item>
                              <ButtonBase className={classes.image}>
                                <ImagePlaceholder
                                  className={classes.img}
                                  alt="Imagem do item do atendimento"
                                  src={itemAtendimento?.Foto}
                                  width={85}
                                  widthOnError={40}
                                  imagePreviewTitle={`Item ${itemAtendimento?.IdProduto}`}
                                />
                              </ButtonBase>
                            </Grid>
                            <Grid item xs={6} sm container>
                              <Grid item xs={12} display="flex">
                                <DataExchange value={itemAtendimento?.DescricaoProduto}/>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} sm container>
                              <Grid 
                                item 
                                xs={12} 
                                style={{
                                  display: 'flex', 
                                  justifyContent: isMobile ? 'space-between' : 'flex-start',
                                  flexDirection: isMobile ? 'row' : 'column',
                                }}
                              >
                                <div>
                                  <DataExchange label="Código do Produto: " value={`${itemAtendimento?.IdProduto}`}/>
                                  <DataExchange label="Tipo de Solicitação: " value={`${itemAtendimento?.TipoSolicitacao === 'DEVOLUCAO' ? ' Devolução' : ' Troca '}`}/>
                                </div>
                                <div>
                                  <DataExchange label="Quantidade Solicitada: " value={`${itemAtendimento?.QuantidadeSolicitada}`}/>
                                  <DataExchange label="Motivo: " value={handleVerifyReason(itemAtendimento?.Motivo)} />
                                  <DataExchange label="Observação: " value={`${itemAtendimento?.Observacao}`}/>
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Paper>
                        </Grid>
                      </Grid>
                    </CardContent>
                  )
                })
              }
              </Grid>
            </Grid>
          </>
        </DialogContent>
        
        <DialogActions>
          <Button
            component={Box}
            onClick={() => onClose({confirmation: false})}
          >
            Cancelar
          </Button>
          <Button
            component={Box}
            onClick={() => onClose({confirmation: true})}
            color="default"
            variant="contained"
          >
            Confirmar
          </Button>
        </DialogActions>
      </> 
    </Dialog>
  );
};

export default OrderConfirmation;
